<template>
  <div class="box-father">
    <div style="height: 100%" v-if="!qusetionDetailDialog">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>上报历史</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="任务状态">
                  <el-select
                    filterable
                    placeholder="请选择任务状态"
                    clearable
                    v-model="form.handleState"
                  >
                    <el-option
                      v-for="item in openFlagOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="案件号">
                  <el-input
                    v-model="form.caseNumber"
                    clearable
                    placeholder="请输入案件号搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入事项名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="点位">
                  <el-input
                    v-model="form.pointName"
                    clearable
                    placeholder="请输入社区或网格名称搜索"
                  ></el-input>
                </el-form-item>
                <el-form-item label="上报时间">
                  <el-date-picker
                    v-model="form.valueTime"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="上报人员">
                  <el-input
                    v-model="form.reportUserName"
                    clearable
                    placeholder="请输入上报人员"
                  ></el-input>
                </el-form-item>
                <el-form-item label="上报部门">
                  <el-input
                    v-model="form.reportDeptName"
                    clearable
                    placeholder="请输入上报部门"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="myReportPageExpFun"
                icon="el-icon-download"
                class="search"
                >导出</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="560"
          >
            <template v-slot:operation="{ scope }">
              <el-button
                @click="qusetionDetail(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >问题详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detail
      v-if="qusetionDetailDialog"
      @closeDetail="qusetionDetailDialog = false"
      :pointInfo="pointInfo"
      title1="任务管理"
      title2="问题详情"
    ></detail>
  </div>
</template>
<script>
import {
  getPointTypeListPage,
  updatePointType,
  delPointType
} from "@/api/point.js";
import {
  myReportPage,
  reportTaskLeftHandleExp,
  reportTaskLeftHandleTotalExp,
  taskLeftHandleImgExp,
  taskIndexFullDel,
  myReportPageExp
} from "@/api/task.js";
import { downloadFile, getDeptTree } from "@/api/systemManagement.js";
import commonTable from "@/components/table/index.vue";
import detail from "../reportproblemAnalysis/components/detail.vue";
export default {
  components: {
    commonTable,
    detail
  },
  data() {
    return {
      form: {
        eventName: "",
        handleState: "",
        reportTimeStart: "",
        reportTimeEnd: "",
        pointName: "",
        reportUserName: "",
        caseNumber: "",
        valueTime: [],
        reportDeptName: ""
      },
      openFlagOptions: [
        {
          label: "未处置",
          value: "未处置"
        },
        {
          label: "已处置",
          value: "已处置"
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "transitionState202501",
            label: "任务状态",
            width: 100
          },
          {
            prop: "caseNumber",
            label: "案件号",
            width: 150
          },
          {
            prop: "taskDetail",
            label: "问题描述",
            width: 160
          },
          {
            prop: "eventName",
            label: "事项名称"
          },
          {
            prop: "communityName",
            label: "社区",
            width: 140
          },
          {
            prop: "blockName",
            label: "网格",
            width: 160
          },
          {
            prop: "reportTime",
            label: "上报时间",
            width: 180
          },
          {
            prop: "reportUserName",
            label: "上报人员",
            width: 120
          },
          {
            prop: "reportDeptName",
            label: "上报部门",
            width: 120
          },
          {
            prop: "fbTime",
            label: "AI确认时间",
            width: 180
          },
          {
            prop: "sqDueTime",
            label: "小循环截止时间",
            width: 180
          },
          {
            prop: "ksDueTime",
            label: "大循环截止时间",
            width: 180
          },
          {
            slot: "operation",
            label: "操作",
            width: 150,
            fixed: "right"
          }
        ]
      },
      curItem: {},
      qusetionDetailDialog: false,
      pointInfo: {},
      dialogPictureVisible: false,
      pictureList: [],
      dialogExportVisible: false,
      exportOneLoading: false,
      exportTwoLoading: false,
      typeExport: ""
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.eventName = "";
      this.form.handleState = "";
      this.form.pointName = "";
      this.form.caseNumber = "";
      this.form.reportUserName = "";
      this.form.reportTimeStart = "";
      this.form.reportTimeEnd = "";
      this.form.valueTime = [];
      this.page.page = 1;
      this.page.size = 10;
      this.form.reportDeptName = "";
      this.getPointTypeListPageFun();
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        pointName: this.form.pointName,
        caseNumber: this.form.caseNumber,
        reportUserName: this.form.reportUserName,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        page: this.page.page,
        size: this.page.size,
        reportDeptName: this.form.reportDeptName
      };
      const res = await myReportPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    },
    qusetionDetail(item) {
      this.pointInfo = item;

      this.qusetionDetailDialog = true;
    },
    // 上报历史-导出
    async myReportPageExpFun() {
      this.exportLoading = true;
      let res = await myReportPageExp({
        eventName: this.form.eventName,
        transitionState202501: this.form.handleState,
        pointName: this.form.pointName,
        caseNumber: this.form.caseNumber,
        reportUserName: this.form.reportUserName,
        reportTimeStart: this.form.valueTime && this.form.valueTime[0],
        reportTimeEnd: this.form.valueTime && this.form.valueTime[1],
        reportDeptName: this.form.reportDeptName
      });
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "上报历史" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
    },
    openNew(list) {
      this.dialogPictureVisible = true;
      this.pictureList = list.map(i => i.url);
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 36px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .map-content {
    width: 375px;
    height: 178px;
    margin: 0 24px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;
    .disposition {
      position: absolute;
      top: -10px;
      right: -80px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px 100px;
}
.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 410px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 390px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }
    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }
    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid #0495ff;
  }
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.yituihui {
  color: #c4c6cc;
}
</style>



// WEBPACK FOOTER //
// src/pages/requestHistory/index.vue